import React from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

import { FONT_NAMES } from 'bento-ordering/base/theme/font';

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: '59px',
    maxWidth: '59px',
    marginTop: '2px',
    justifyContent: 'left',
    marginRight: '1px',
    paddingLeft: 0,
    paddingRight: 0,
    borderRadius: 0,
    paddingBottom: '1px',
    borderBottom: ({ isHighlighted }) =>
      `2px ${
        isHighlighted ? theme.palette.secondary.main : 'transparent'
      } solid`,
    color: ({ isHighlighted }) =>
      `${
        !isHighlighted
          ? theme.palette.text.secondary
          : theme.palette.text.primary
      }`,
    '&:hover': {
      color: theme.palette.secondary.main
    },
    [theme.breakpoints.down('md')]: {
      marginRight: '16px'
    }
  },
  label: {
    maxWidth: '58px'
  }
}));

const MenuSectionBarMoreButton = ({ onClick, isHighlighted, isExpanded }) => {
  const classes = useStyles({ isHighlighted });

  return (
    <Button
      classes={classes}
      aria-controls="more-dropdown"
      aria-haspopup="true"
      onClick={onClick}
      id="more-dropdown-btn"
      data-testid="more-dropdown-btn"
      tabIndex="-1"
    >
      <span
        style={{
          minWidth: '65px'
        }}
      >
        <span
          style={{
            textTransform: 'capitalize',
            position: 'relative',
            top: '-1px',
            fontSize: 16,
            letterSpacing: 0.25,
            fontFamily: FONT_NAMES.med
          }}
        >
          More
        </span>
        <Box
          display="inline"
          p={'0 0 0 0'}
          m={'0 -1px 0 0'}
          style={{
            position: 'relative',
            top: '6px'
          }}
        >
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Box>
      </span>
    </Button>
  );
};

MenuSectionBarMoreButton.propTypes = {
  onClick: PropTypes.func,
  classes: PropTypes.shape({}),
  isHighlighted: PropTypes.bool,
  isExpanded: PropTypes.bool
};

export default MenuSectionBarMoreButton;
